/**
 * Rivaro — Text reveal on headings
 * Splits headings into words and reveals them with motion blur + slide-up
 * stagger when entering viewport.
 *
 * Auto-targets h1, h2 inside main sections.
 * Skips:
 *   - Headings inside header, footer, hero (ya animados)
 *   - Headings con HTML hijo complejo (links, spans, etc.) — solo texto puro
 *   - Headings vacíos o muy cortos
 */
(function () {
  if (typeof IntersectionObserver === 'undefined') return;

  var STAGGER_MS = 60;
  var REVEAL_ATTR = 'data-rivaro-text-reveal';

  function shouldExclude(el) {
    return (
      el.closest('.header-wrapper') ||
      el.closest('[class*="header-sections--"]') ||
      el.closest('.rivaro-hero') ||
      el.closest('.rivaro-loader') ||
      el.closest('footer') ||
      el.closest('[class*="announcement-bar"]') ||
      el.closest('[class*="shopify-section-header"]') ||
      el.closest('[class*="shopify-section-footer"]')
    );
  }

  function canSplit(heading) {
    // Solo headings con texto puro (sin children que no sean <br>)
    if (heading.children.length > 0) {
      var children = Array.from(heading.children);
      var allBr = children.every(function (c) { return c.tagName === 'BR'; });
      if (!allBr) return false;
    }
    var text = heading.textContent && heading.textContent.trim();
    return text && text.length >= 2;
  }

  function splitHeading(heading) {
    if (heading.hasAttribute(REVEAL_ATTR)) return;
    if (!canSplit(heading)) return;

    var text = heading.textContent.trim();
    var words = text.split(/\s+/);
    if (words.length === 0) return;

    // Limpiar el heading sin innerHTML
    while (heading.firstChild) heading.removeChild(heading.firstChild);

    words.forEach(function (word, i) {
      var span = document.createElement('span');
      span.className = 'rivaro-tr-word';
      span.style.setProperty('--rivaro-tr-delay', (i * STAGGER_MS) + 'ms');
      span.appendChild(document.createTextNode(word));
      heading.appendChild(span);
      // Espacio entre palabras (text node, no innerHTML)
      if (i < words.length - 1) {
        heading.appendChild(document.createTextNode(' '));
      }
    });

    heading.setAttribute(REVEAL_ATTR, '');
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        requestAnimationFrame(function () {
          entry.target.classList.add('is-revealed');
        });
        obs.unobserve(entry.target);
      });
    },
    {
      threshold: 0.2,
      rootMargin: '0px 0px -10% 0px'
    }
  );

  function init() {
    var headings = document.querySelectorAll('main h1, main h2');
    headings.forEach(function (h) {
      if (shouldExclude(h)) return;
      splitHeading(h);
      if (!h.hasAttribute(REVEAL_ATTR)) return;
      var rect = h.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85 && rect.bottom > 0) {
        requestAnimationFrame(function () {
          h.classList.add('is-revealed');
        });
      } else {
        observer.observe(h);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
